/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.1.0
 * @since 1.1.0
 */

import { IGTMOperation } from './index';

export const clickLinkAllPaymentsWidgetHistoryPayments: IGTMOperation = ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v217-e13',
    'event_cat': 'История платежей',
    'event_name': 'clickElement',
    'event_param': 'Все платежи',
});
